// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/dff6c475/" + chunkId + "." + __webpack_require__.h() + ".vdff6c475.js";
};